const MOCK_API_BASE_URL = 'https://6a37eea0c105017aa6397789.mockapi.io';

export const LIKES_URL = `${MOCK_API_BASE_URL}/likes`;
export const COMMENTS_URL = `${MOCK_API_BASE_URL}/comments`;
